export default __webpack_public_path__ + "static/media/in_1.67c21e1a.png";